var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEducation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Graduation-Hat--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Graduation Hat Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M23.325 7.258a0.654 0.654 0 0 1 0 1.214l-10.762 4.34c-0.422 0.17 -0.894 0.169 -1.314 -0.003L3.26 9.539l0 7.901a2.128 2.128 0 0 1 1.262 1.95v3.452a0.5 0.5 0 0 1 -0.5 0.5H0.753a0.5 0.5 0 0 1 -0.5 -0.5V19.39c0 -0.873 0.517 -1.62 1.263 -1.951l0 -8.615 -0.867 -0.354a0.655 0.655 0 0 1 0 -1.212l10.6 -4.338c0.42 -0.172 0.892 -0.173 1.314 -0.003l10.762 4.34Zm-10.273 6.768 5.85 -2.359v3.837a0.795 0.795 0 0 1 -0.344 0.668c-0.888 0.596 -3.417 2.074 -6.65 2.074 -3.234 0 -5.647 -1.48 -6.486 -2.074a0.787 0.787 0 0 1 -0.323 -0.65v-3.816l5.654 2.314a3.055 3.055 0 0 0 2.3 0.006Z",
    clipRule: "evenodd",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEducation);
export default ForwardRef;